import {Component, ElementRef, inject, ViewChild} from '@angular/core';
import {NgImageSliderModule} from "ng-image-slider";
import {WorkStore} from "./store/work-store";
import {MarkdownComponent} from "ngx-markdown";
import {FooterComponent} from "../footer/footer.component";
import {NavHeaderComponent} from "../nav-header/nav-header.component";
import {DotsLoaderComponent} from "../../../../core/helper-components/dots-loader/dots-loader.component";

@Component({
  selector: 'app-work-details',
  templateUrl: './work-details.component.html',
  styleUrls: ['./work-details.component.scss'],
  standalone: true,
  imports: [
    NgImageSliderModule,
    MarkdownComponent,
    FooterComponent,
    NavHeaderComponent,
    DotsLoaderComponent
  ],
  providers: [WorkStore]
})
export class WorkDetailsComponent {

  @ViewChild('container') container!: ElementRef;

  readonly #store = inject(WorkStore);
  protected readonly work = this.#store.work;
  protected readonly images = this.#store.images;
  protected readonly isLoading = this.#store.isLoading;

  reload() {
    this.#store.reload();
  }

}
